import getLocalizedText from "../../../Utils";

export default function renderDefaultSubmodelPdf(builder, submodel) {
  const title = getLocalizedText(submodel.displayName || submodel.idShort, "N/A", builder.locale );
  const description = getLocalizedText(submodel.description, "No description available.", builder.locale );
  builder.sectionHeader(title);
  builder.textBlock(description);
  builder.addDividerLine();

  const elements = submodel.submodelElements || [];

  if (elements.length === 0) {
    builder.textBlock("No submodel elements available.");
    return;
  }

  elements.forEach((el) => {
    renderElement(builder, el, 1);
  });
}

function renderElement(builder, el, indent) {
  const type = el.modelType;
  const displayName =  getLocalizedText(el.displayName, el.idShort, builder.locale );

  if (type === "SubmodelElementCollection" || type === "SubmodelElementList") {
    builder.sectionHeaderSmall(displayName);
    (el.value || []).forEach((child) =>
      renderElement(builder, child, indent)
    );
    return;
  }

  const value = getLocalizedText(el.value, "N/A", builder.locale );

  builder.keyValueRow(displayName, value, indent);
}
